import { render } from "./NewsListingView.vue?vue&type=template&id=d1f99116&scoped=true"
import script from "./NewsListingView.vue?vue&type=script&lang=js"
export * from "./NewsListingView.vue?vue&type=script&lang=js"

import "./NewsListingView.vue?vue&type=style&index=0&id=d1f99116&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1f99116"]])

export default __exports__